import { SlideDown } from 'react-slidedown';
import styled from 'styled-components/macro';

export default styled(SlideDown)`
  .react-slidedown& {
    transition-duration: .2s;
    transition-timing-function: ease-in-out;
  }
`;
